var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.833 5.165a.835.835 0 000 1.67v-1.67zm8.334 1.67a.835.835 0 000-1.67v1.67zM1.75.998a.835.835 0 000 1.67V.998zm12.5 1.67a.835.835 0 100-1.67v1.67zM5.917 9.332a.835.835 0 100 1.67v-1.67zm4.166 1.67a.835.835 0 100-1.67v1.67zm-6.25-4.167h8.334v-1.67H3.833v1.67zM1.75 2.668h12.5V.998H1.75v1.67zm4.167 8.334h4.166v-1.67H5.917v1.67z",
    fill: "#667A8C"
  })));
}
export default __webpack_public_path__ + "static/media/filter.d73528db.svg";
export { SvgFilter as ReactComponent };